/**
 * Single source of truth for the contrast-adjusted "state" color shades
 * shared by design atoms (`OptionButtonGroup`, `Pill`) and the forms
 * option-color palette (`app/forms/optionColors`).
 */
export type StateColor = 'green' | 'red' | 'blue' | 'yellow';

export const STATE_COLOR_SHADES: Record<StateColor, string> = {
  green: 'green.8',
  red: 'red.8',
  blue: 'blue.7',
  yellow: 'yellow.7',
};

export const stateColorCssVar = (color: StateColor): string =>
  `var(--mantine-color-${STATE_COLOR_SHADES[color].replace('.', '-')})`;
